import { colors } from 'css/constants';

// TODO: migrate to styled-components?
// https://github.com/JedWatson/react-select/issues/1679#issuecomment-307016615
const select = (isError, disabled) => ({
  menu: (base) => ({
    ...base,
    borderRadius: 0
  }),
  control: (base, { isFocused }) => {
    const borderColor = isError ? colors.red : '#CCCCCB';

    return {
      ...base,
      backgroundColor: disabled ? colors.lightGrey : '#FFF',
      borderWidth: '1px',
      borderColor: disabled ? colors.lightGrey : borderColor,
      borderRadius: '3px',
      padding: 0,
      minHeight: 0,
      ':hover': {
        borderColor
      },
      ...(isFocused && {
        outlineOffset: -2,
        outline: 'auto  -webkit-focus-ring-color',
        boxShadow: 'none'
      })
    };
  },
  input: (base) => ({
    ...base,
    padding: '0.5em 0',
    lineHeight: 1
  }),
  placeholder: (base) => ({
    ...base,
    color: colors.midGrey
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 0.5em'
  }),
  singleValue: (base) => ({
    ...base,
    color: disabled ? colors.midGrey : 'inherit',
    width: 'calc(100% - 24px)'
  })
});

export default { select };
